import { useCallback, useRef } from 'react'

/**
 * Sayfa değiştirip geri dönünce kaydırma konumunu koruyan `ref`.
 *
 * Gerek şu: `App` sayfaları koşullu render ediyor (`aktif === 'market' && …`),
 * yani sayfadan çıkmak bileşeni SÖKÜYOR. Mobilde kontrat listesinin altındaki
 * bir kontrata dokunup İşlem ekranına gitmek, geri dönünce listeyi en üstten
 * başlatıyordu — kullanıcı her seferinde aynı yere kadar iniyordu.
 *
 * Konum modül kapsamında (React durumunda değil): bileşen sökülünce durum da
 * gider, hafızanın sökülmeden SAĞ ÇIKMASI gerekiyor. Sayfa yenilenince sıfırlanır
 * — kalıcı olması istenmiyor, "aynı oturumda kaldığın yer" kadarı isteniyor.
 *
 * Geri yükleme neden `useLayoutEffect` değil de callback ref: kap bazen ilk
 * render'da DOM'da olmuyor (kontrat listesi veri gelene kadar `panel empty`
 * basıyor). Callback ref düğüm gerçekten TAKILDIĞINDA çalışır; efekt bir kez
 * koşup düğümü ıskalardı. Temizlik işlevi React 19 sözleşmesi (düğüm sökülürken
 * çağrılır) — son konumu orada yazıyoruz ki `scroll` olayı kaçsa bile kayıt tam olsun.
 */

const konumlar = new Map<string, number>()

export function useScrollMemory<T extends HTMLElement>(anahtar: string) {
  //: Aynı anahtarla ikinci bir kap takılırsa (StrictMode çift-mount) eskisinin
  //  dinleyicisi bırakılmasın.
  const birak = useRef<(() => void) | null>(null)

  return useCallback(
    (el: T | null) => {
      birak.current?.()
      birak.current = null
      if (!el) return

      el.scrollTop = konumlar.get(anahtar) ?? 0
      const yaz = () => konumlar.set(anahtar, el.scrollTop)
      el.addEventListener('scroll', yaz, { passive: true })
      birak.current = () => {
        yaz()
        el.removeEventListener('scroll', yaz)
      }
      return birak.current
    },
    [anahtar],
  )
}
